import { type Ref } from 'react';
import { SearchIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { INPUT_BASE, INPUT_STATE } from './form/input/inputStyles';

export const SearchBar = ({
    searchTerm = '',
    setSearchTerm = () => {},
    search = () => {},
    placeholder = 'Search or type command...',
    showKeyboardShortcut = false,
    className = '',
    ref,
}: {
    searchTerm: string;
    setSearchTerm: (term: string) => void;
    search?: () => void;
    placeholder: string;
    showKeyboardShortcut?: boolean;
    className?: string;
    ref?: Ref<HTMLInputElement>;
}) => {
    return (
        <div className="relative">
            <span className="absolute -translate-y-1/2 pointer-events-none left-3 top-1/2 text-mp-muted">
                <SearchIcon className="size-5" />
            </span>
            <input
                ref={ref}
                type="text"
                aria-label={placeholder}
                placeholder={placeholder}
                className={twMerge(
                    INPUT_BASE,
                    INPUT_STATE.default,
                    'pl-10 pr-14 shadow-theme-xs xl:w-[430px]',
                    className
                )}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            {showKeyboardShortcut && (
                <button
                    type="button"
                    aria-label="Open the command menu"
                    className="absolute right-3 top-1/2 inline-flex -translate-y-1/2 items-center gap-0.5 rounded-lg border border-mp-input bg-mp-background px-2 py-1 text-xs text-mp-muted"
                    onClick={search}
                >
                    <span> ⌘ </span>
                    <span> K </span>
                </button>
            )}
        </div>
    );
};
